import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import classes from './Alert.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import MuiPlaceholder from '../controls/MuiPlaceholder/MuiPlaceholder';
import { setAlertIsOpen } from '../../store/actions/general';

const Alert = ({ socket }) => {
  const banner = window.sutherland_variables.ui.banner;
  const alerts = !Array.isArray(banner) ? [] : banner;

  const { muiFontLoaded, alertIsOpen } = useSelector((state) => state.general);
  const dispatch = useDispatch();

  const closeAlert = () => {
    dispatch(setAlertIsOpen(false));
  };

  alerts.sort((a, b) => {
    return a.order - b.order;
  });
  if (alertIsOpen) {
    return (
      <div>
        {
          alerts.slice(0, 1).map((alert) => {
            return (
              <div
              key={alert.order}
                className={`${classes.AlertContainer} ${
                  alert.type === 'success'
                    ? classes.AlertSuccess
                    : alert.type === 'warning'
                    ? classes.AlertWarning
                    : alert.type === 'info'
                    ? classes.AlertInfo
                    : classes.AlertError
                }`}
              >
                <div className={classes.AlertIconContainer}></div>
                <div className={classes.AlertContentContainer}>
                  <div className={classes.AlertTitle}>
                    <ReactMarkdown
                      children={alert.title}
                      remarkPlugins={[remarkGfm]}
                    />
                  </div>
                  <div className={classes.AlertMessage}>
                    <ReactMarkdown
                      children={alert.body}
                      remarkPlugins={[remarkGfm]}
                      components={{
                        a: ({ node, ...props }) => (
                          <a {...props} target="_blank" rel="noopener noreferrer">
                            {props.children}
                          </a>
                        ),
                      }}
                    />
                  </div>
                </div>
                <div className={classes.AlertCloseButtonContainer}>
                  <button
                    className={classes.AlertIconButton}
                    onClick={closeAlert}
                  >
                    <MuiPlaceholder
                      isMuiFontLoaded={muiFontLoaded}
                      element={<div>close</div>}
                    />
                  </button>
                </div>
              </div>
            );
          })}
      </div>
    );
 }
 return null;
};

export default Alert;
